"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _actionMenuItem = _interopRequireDefault(require("./action-menu-item.shape"));

var _actionMenuItem2 = _interopRequireDefault(require("./action-menu-item/action-menu-item"));

const ActionMenu = props => {
  const {
    items,
    onSelect,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('action-menu', className)
  }, items.map(item => {
    const {
      value,
      name
    } = item;
    return /*#__PURE__*/_react.default.createElement(_actionMenuItem2.default, {
      key: value,
      value: value,
      name: name,
      onClick: () => onSelect(item)
    });
  }));
};

ActionMenu.propTypes = {
  onSelect: _propTypes.default.func.isRequired,
  items: _propTypes.default.arrayOf(_actionMenuItem.default).isRequired,
  className: _propTypes.default.string
};
ActionMenu.defaultProps = {
  className: ''
};
var _default = ActionMenu;
exports.default = _default;